import React, { ReactNode } from 'react';

import { CtaButton, CtaButtonProps } from 'components/global/CtaButton';
import { SYNTHETIC_TEST_IDS } from 'consts/syntheticTestIds';

import {
  buttonStyles,
  HeaderContainer,
  InnerContainer,
  MainContainer,
} from './WhatWeTreat.style';
import { Glyphs } from './components/Glyphs';

export interface WhatWeTreatGlyphType {
  name: string;
  glyph: ReactNode;
}

export interface WhatWeTreatProps {
  header?: string;
  glyphs: WhatWeTreatGlyphType[];
  ctaButton?: CtaButtonProps;
}

const moduleName = 'whatWeTreat';

export const WhatWeTreat = ({
  header,
  glyphs,
  ctaButton,
}: WhatWeTreatProps) => {
  return (
    <MainContainer data-module={moduleName}>
      <InnerContainer>
        {header && <HeaderContainer>{header}</HeaderContainer>}
        <Glyphs content={glyphs} />
        {ctaButton && (
          <CtaButton
            {...ctaButton}
            module={moduleName}
            css={buttonStyles}
            data-synthetics-id={SYNTHETIC_TEST_IDS.bodyCta}
          />
        )}
      </InnerContainer>
    </MainContainer>
  );
};
